import {TableDefinition} from '../../models';

export const CUSTOM_FIELD_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.CustomField.id',
    prop: 'id',
    visible: false,
    objectName: 'CustomFieldDefinition',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.CustomField.name',
    prop: 'name',
    visible: true,
    objectName: 'CustomFieldDefinition',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.CustomField.label',
    prop: 'label',
    visible: true,
    objectName: 'CustomFieldDefinition',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.CustomField.type',
    prop: 'type',
    visible: true,
    objectName: 'CustomFieldDefinition',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.CustomField.active',
    prop: 'isactive',
    visible: true,
    objectName: 'CustomFieldDefinition',
    searchFieldType: 'NUMBER',
  }
];
